import { defineStore } from 'pinia';
import { getInitialTheme, persistTheme, type ThemeMode } from '@/utils/theme';

export const useUiStore = defineStore('ui', {
  state: () => ({
    theme: getInitialTheme(),
  }),
  getters: {
    isLightTheme: (state) => state.theme === 'light',
  },
  actions: {
    toggleTheme() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark';
      persistTheme(this.theme);
    },
    setTheme(theme: ThemeMode) {
      this.theme = theme;
      persistTheme(theme);
    },
  },
});
